<template>
  <div :class="renderItemClass">
    <div class="shop-header">
      <span class="text">我上传的：</span>
      <div class="genericName">{{ purchaseListInfo.genericName }}</div>
      <div class="spec">{{ purchaseListInfo.spec }}</div>
      <div class="productFactoryName">{{ purchaseListInfo.productFactoryName }}</div>
      <div class="approval" v-if="purchaseListInfo.approval">{{ purchaseListInfo.approval }}</div>
      <div class="purchaseNum" v-if="purchaseListInfo.purchaseNum">×{{ purchaseListInfo.purchaseNum }}</div>
      <div class="purchasePrice" v-if="purchaseListInfo.purchasePrice">￥{{ purchaseListInfo.purchasePrice }}</div>
    </div>
    <div class="shop-body">
      <div class="body-desc">
        <img
          class="desc-img"
          v-if="matchInfo.itemMainImg && matchInfo.itemMainImg.includes('http')"
          :src="matchInfo.itemMainImg + '?x-oss-process=image/resize,w_240/quality,q_90'"
          alt=""
        />
        <img class="desc-img" v-else :src="require('@/assets/img/goods-empty.png')" />
        <img class="goods-label" :src="matchInfo.itemLabelIcon" v-if="matchInfo.itemLabelIcon" />
        <div class="text-desc">
          <div class="itemTitle">{{ matchInfo.itemTitle }}</div>
          <div class="productFactoryName">{{ matchInfo.productFactoryName }}</div>
          <template v-if="isSpecial">
            <div class="specialItemFlag">
              <div class="tag">特价</div>
            </div>
          </template>
        </div>
      </div>
      <div class="spec">
        <span>{{ matchInfo.spec }}</span>
      </div>
      <div class="approval">
        <span>
          {{ matchInfo.approval }}
        </span>
      </div>
      <div class="expirationDate">
        <span>有效期：{{ matchInfo.expirationDate }}</span>
      </div>
      <div class="itemSalePrice">
        <span>￥{{ itemSalePrice }}</span>
      </div>
      <div class="inventory">
        <div class="goshop">
          <div class="btn" @click="goshop">查看商品</div>
        </div>
        <div class="num">库存：{{ matchInfo.inventory }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { priceFenToYuan } from '@/helpers/utils';
import classNames from 'classnames';
export default {
  computed: {
    isEnd() {
      return this.$attrs.isEnd;
    },
    purchaseListInfo() {
      return this.$attrs.info.purchaseListInfo;
    },
    matchInfo() {
      return this.$attrs.info.matchInfo;
    },
    itemSalePrice() {
      return priceFenToYuan(this.matchInfo.itemSalePrice);
      // return (this.matchInfo.itemSalePrice / 100).toFixed(2);
    },
    renderItemClass() {
      return classNames({
        'shop-item': true,
        'end-item': this.isEnd,
        'matchScoreLow-66': this.matchInfo.matchScore < 66
      });
    },
    isSpecial() {
      return this.matchInfo.activityType === 'SPECIAL_PRICE';
    }
  },
  methods: {
    goshop() {
      const itemCode = this.matchInfo.itemCode;

      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-sy-zncgyzkspB2B',
        custom: {
          itemTitle: this.matchInfo.itemTitle,
          itemCode: itemCode
        }
      });
      // /goodsDetails/499693205700617
      const { origin, pathname } = location;
      const url = `${origin}${pathname}#/goodsDetails/${itemCode}`;
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
$borderColor: rgba(136, 136, 136, 0.2);
@mixin ellipsis($w: null, $l: 1) {
  max-width: $w;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $l;
  -webkit-box-orient: vertical;
}
.end-item {
  border-bottom: 1px dashed $borderColor;
}
.matchScoreLow-66 {
  background: #fff2c7;
}
.shop-item {
  .shop-header {
    display: flex;
    padding: 16px;
    align-items: center;
    position: relative;
    border: 1px dashed $borderColor;
    .text,
    .genericName,
    .spec,
    .productFactoryName,
    .approval,
    .purchaseNum,
    .purchasePrice {
      font-size: 14px;
      color: #333;
      margin-left: 16px;
    }
    .text,
    .genericName {
      margin-left: 0;
    }

    .genericName {
      @include ellipsis($w: 140px);
    }
    .spec {
      @include ellipsis($w: 140px);
    }
    .productFactoryName {
      @include ellipsis($w: 140px);
    }
    .approval {
      @include ellipsis($w: 140px);
    }
    .purchasePrice {
      color: #d96900;
    }
  }
  .shop-body {
    display: flex;
    padding: 16px;
    border: 1px dashed $borderColor;
    border-top: none;
    border-bottom: none;

    .body-desc {
      display: flex;
      position: relative;
      .goods-label {
        position: absolute;
        top: 0;
        left: 0;
        height: 12px;
      }
      .desc-img {
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }
      .text-desc {
        display: flex;
        flex-direction: column;
        width: 230px;
        .itemTitle {
          font-size: 12px;
          color: #333;
          @include ellipsis($l: 2, $w: 230px);
        }
        .productFactoryName {
          margin-top: 8px;
          color: #888888;
          font-size: 12px;
          @include ellipsis($w: 230px);
        }
        .specialItemFlag {
          display: flex;
          margin-top: 8px;
          .tag {
            padding: 0px 4px;
            color: #fff;
            background: #ff4e47;
            font-size: 12px;
          }
        }
      }
    }
    @mixin baseSpec {
      font-size: 12px;
      color: #333;
      margin-left: 32px;
      width: 184px;
      span {
        @include ellipsis($l: 1);
        word-break: break-all;
      }
    }
    .spec {
      @include baseSpec;
      margin-left: 80px;
    }
    .approval {
      @include baseSpec;
      width: 188px;
    }
    .expirationDate {
      @include baseSpec;
      width: 184px;
      span {
        -webkit-line-clamp: 2;
      }
    }
    .itemSalePrice {
      font-size: 18px;
      color: #d96900;
      width: 70px;
      margin-left: 108px;
    }
    .inventory {
      margin-left: 94px;
      width: 114px;
      display: flex;
      flex-direction: column;
      .goshop {
        .btn {
          cursor: pointer;
          width: 64px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          background: #1e8dff;
          font-size: 12px;
          color: #fff;
        }
      }
      .num {
        color: #888888;
        font-size: 12px;
        margin-top: 4px;
      }
    }
  }
}
</style>
